var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-logo"}),_c('div',{staticClass:"google-login",on:{"click":function($event){return _vm.openGoogleLogin()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }